import update from 'immutability-helper';
import shortid from 'shortid';
import { createReducer } from 'redux-create-reducer';
import actionsAndConstants from '../../../shared/actionsAndConstants';

const {
  app: {
    constants: appConstants
  },
  topNavbar: {
    constants: topNavbarConstants
  }
} = actionsAndConstants;

const initialState = [];

const clearDialog = (state, { payload: id } = {}) => (
  state.filter(dialog => dialog.id !== id)
);

const hideDialog = (state, { payload: id } = {}) => {
  const dialogIndex = state.findIndex(dialog => dialog.id === id);
  return update(state, { [dialogIndex]: { show: { $set: false } } });
};

const logoutSucceeded = () => initialState;

const showDialog = (state, { payload: dialog } = {}) => (
  update(state, { $push: [{
    id: shortid.generate(),
    ...dialog
  }] })
);

const dialogsReducer = createReducer(initialState, {
  [appConstants.clearDialog]: clearDialog,
  [appConstants.hideDialog]: hideDialog,
  [appConstants.showDialog]: showDialog,
  [topNavbarConstants.logoutSucceeded]: logoutSucceeded,
});

export default dialogsReducer;



// WEBPACK FOOTER //
// ./src/containers/Root/reducer/dialogs.js